import React, { useState, useContext, useEffect } from "react";
import styled, { css } from "styled-components";
import { Switch, Route, Link } from "react-router-dom";
import PAh2 from "../PAh2";
import PAtabs from "../PAtabs";
import { FormGroup, Select } from 'xsolla-uikit';

export default function PApsGateways () {

  const [filter, setFilter] = useState('all')

    return (


     <div>

<FormGroup indentation="lg">
  <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', }}>
    <PAh2 title="Gateways" indentation="xs"></PAh2>
    <CssH2Extra>
      <PAtabs
        handleTab={nw => {
          setFilter(nw)
        }}
        appearance="secondary"
        active = {filter}
        items={[
          {
            name: 'All',
            // icon: "profile",
            stateName: "all",
          },
          {
            name: 'Testing',
            counter: 7,
            // icon: "profile",
            stateName: "testing",
          },
          {
            name: 'Configured',
            counter: 3,
            // icon: "profile",
            stateName: "configured",
          },
        ]}
      /></CssH2Extra>
  </div>
</FormGroup>

<div className="gateways-list__container">

<div className="gateways-list__notification">
<div className="xsui-notification xsui-notification--status-warning xsui-notification--appearance-default xsui-notification--size-md xsui-notification--full-width">
<div className="xsui-notification__content-wrapper">
<div className="xsui-notification__icon" />
<div className="xsui-notification__message">
<div className="xsui-notification__entry">
<span>Xsolla Payment Gateway allows receiving payouts directly from a payment system available within the Pay Station interface. You can use this model if you want to receive direct payouts from payment systems of your choice. Under this model, the interface will not change, but Xsolla serves only as a Technical Service Provider. To configure Payment Gateway, please review the list of <a href="https://developers.xsolla.com/doc/pay-station/#guides_pay_station_glossary_gateways" target="_blank">excluded features</a> and sign the agreement. Cost: 1.25% per transaction + $0.10. For more detailed information, please contact your Xsolla Account Manager.</span>
</div>
</div>
</div>
</div>
</div>
<div className="gateways-list">
<div className="gateways-list__item">
<div className="gateway-card gateway-card--click-enabled">
<div className="gateway-card__header">
<div className="gateway-card__title">PayPal</div>
<img className="gateway-card__image" src="//cdn3.xsolla.com/paymentoptions/paystation/theme_33/108x63/24.1564480958.png" />
</div>
<div className="gateway-card__delimiter" />
<div className="gateway-card__content">
<div className="gateways-list__item-panel">
<span className="gateways-list__item-panel-configure">
<div className="gateways-list__item-panel-configure-shape" />Configure</span>
</div>
</div>
</div>
</div>
<div className="gateways-list__item">
<div className="gateway-card gateway-card--click-enabled">
<div className="gateway-card__header">
<div className="gateway-card__title">Braintree</div>
<img className="gateway-card__image" src="//cdn3.xsolla.com/paymentoptions/paystation/theme_33/108x63/2431.1532667961.png" />
</div>
<div className="gateway-card__delimiter" />
<div className="gateway-card__content">
<div className="gateways-list__item-panel">
<span className="gateways-list__item-panel-configure">
<div className="gateways-list__item-panel-configure-shape" />Configure</span>
</div>
</div>
</div>
</div>
<div className="gateways-list__item">
<div className="gateway-card gateway-card--click-enabled">
<div className="gateway-card__header">
<div className="gateway-card__title">BitPay</div>
<img className="gateway-card__image" src="//cdn3.xsolla.com/paymentoptions/paystation/theme_33/108x63/3426.1511158110.png" />
</div>
<div className="gateway-card__delimiter" />
<div className="gateway-card__content">
<div className="gateways-list__item-panel">
<span className="gateways-list__item-panel-configure">
<div className="gateways-list__item-panel-configure-shape" />Configure</span>
</div>
</div>
</div>
</div>
<div className="gateways-list__item">
<div className="gateway-card gateway-card--click-enabled">
<div className="gateway-card__header">
<div className="gateway-card__title">ATM</div>
<img className="gateway-card__image" src="//cdn3.xsolla.com/paymentoptions/paystation/theme_33/108x63/64.1551872923.png" />
</div>
<div className="gateway-card__delimiter" />
<div className="gateway-card__content">
<div className="gateways-list__item-panel">
<span className="gateways-list__item-panel-configure">
<div className="gateways-list__item-panel-configure-shape" />Configure</span>
</div>
</div>
</div>
</div>
<div className="gateways-list__item">
<div className="gateway-card gateway-card--click-enabled">
<div className="gateway-card__header">
<div className="gateway-card__title">Alfa Click</div>
<img className="gateway-card__image" src="//cdn3.xsolla.com/paymentoptions/paystation/theme_33/108x63/309.1521725031.png" />
</div>
<div className="gateway-card__delimiter" />
<div className="gateway-card__content">
<div className="gateways-list__item-panel">
<span className="gateways-list__item-panel-configure">
<div className="gateways-list__item-panel-configure-shape" />Configure</span>
</div>
</div>
</div>
</div>
<div className="gateways-list__item">
<div className="gateway-card gateway-card--click-enabled">
<div className="gateway-card__header">
<div className="gateway-card__title">Alfa-Bank</div>
<img className="gateway-card__image" src="//cdn3.xsolla.com/paymentoptions/paystation/theme_33/108x63/1845.1481263562.png" />
</div>
<div className="gateway-card__delimiter" />
<div className="gateway-card__content">
<div className="gateways-list__item-panel">
<span className="gateways-list__item-panel-configure">
<div className="gateways-list__item-panel-configure-shape" />Configure</span>
</div>
</div>
</div>
</div>
<div className="gateways-list__item">
<div className="gateway-card gateway-card--click-enabled">
<div className="gateway-card__header">
<div className="gateway-card__title">Alipay</div>
<img className="gateway-card__image" src="//cdn3.xsolla.com/paymentoptions/paystation/theme_33/108x63/311.1553774880.png" />
</div>
<div className="gateway-card__delimiter" />
<div className="gateway-card__content">
<div className="gateways-list__item-panel">
<span className="gateways-list__item-panel-configure">
<div className="gateways-list__item-panel-configure-shape" />Configure</span>
</div>
</div>
</div>
</div>
<div className="gateways-list__item">
<div className="gateway-card gateway-card--click-enabled">
<div className="gateway-card__header">
<div className="gateway-card__title">BOKU: Pay by Mobile</div>
<img className="gateway-card__image" src="//cdn3.xsolla.com/paymentoptions/paystation/theme_33/108x63/579.1521723075.png" />
</div>
<div className="gateway-card__delimiter" />
<div className="gateway-card__content">
<div className="gateways-list__item-panel">
<span className="gateways-list__item-panel-configure">
<div className="gateways-list__item-panel-configure-shape" />Configure</span>
</div>
</div>
</div>
</div>
<div className="gateways-list__item">
<div className="gateway-card gateway-card--click-enabled">
<div className="gateway-card__header">
<div className="gateway-card__title">BoaCompra</div>
<img className="gateway-card__image" src="//cdn3.xsolla.com/paymentoptions/paystation/theme_33/108x63/2867.1447071168.png" />
</div>
<div className="gateway-card__delimiter" />
<div className="gateway-card__content">
<div className="gateways-list__item-panel">
<span className="gateways-list__item-panel-configure">
<div className="gateways-list__item-panel-configure-shape" />Configure</span>
</div>
</div>
</div>
</div>
<div className="gateways-list__item">
<div className="gateway-card gateway-card--click-enabled">
<div className="gateway-card__header">
<div className="gateway-card__title">Chase</div>
<img className="gateway-card__image" src="//cdn3.xsolla.com/paymentoptions/paystation/theme_33/108x63/2841.1469192946.png" />
</div>
<div className="gateway-card__delimiter" />
<div className="gateway-card__content">
<div className="gateways-list__item-panel">
<span className="gateways-list__item-panel-configure">
<div className="gateways-list__item-panel-configure-shape" />Configure</span>
</div>
</div>
</div>
</div>
<div className="gateways-list__item">
<div className="gateway-card gateway-card--click-enabled">
<div className="gateway-card__header">
<div className="gateway-card__title">DotPay</div>
<img className="gateway-card__image" src="//cdn3.xsolla.com/paymentoptions/paystation/theme_33/108x63/308.1473833553.png" />
</div>
<div className="gateway-card__delimiter" />
<div className="gateway-card__content">
<div className="gateways-list__item-panel">
<span className="gateways-list__item-panel-configure">
<div className="gateways-list__item-panel-configure-shape" />Configure</span>
</div>
</div>
</div>
</div>
<div className="gateways-list__item">
<div className="gateway-card gateway-card--click-enabled">
<div className="gateway-card__header">
<div className="gateway-card__title">Ethereum</div>
<img className="gateway-card__image" src="//cdn3.xsolla.com/paymentoptions/paystation/theme_33/108x63/3428.1515627208.png" />
</div>
<div className="gateway-card__delimiter" />
<div className="gateway-card__content">
<div className="gateways-list__item-panel">
<span className="gateways-list__item-panel-configure">
<div className="gateways-list__item-panel-configure-shape" />Configure</span>
</div>
</div>
</div>
</div>
<div className="gateways-list__item">
<div className="gateway-card gateway-card--click-enabled">
<div className="gateway-card__header">
<div className="gateway-card__title">GoCash Game Card</div>
<img className="gateway-card__image" src="//cdn3.xsolla.com/paymentoptions/paystation/theme_33/108x63/239.1474955322.png" />
</div>
<div className="gateway-card__delimiter" />
<div className="gateway-card__content">
<div className="gateways-list__item-panel">
<span className="gateways-list__item-panel-configure">
<div className="gateways-list__item-panel-configure-shape" />Configure</span>
</div>
</div>
</div>
</div>
<div className="gateways-list__item">
<div className="gateway-card gateway-card--click-enabled">
<div className="gateway-card__header">
<div className="gateway-card__title">KarmaKoin</div>
<img className="gateway-card__image" src="//cdn3.xsolla.com/paymentoptions/paystation/theme_33/108x63/2772.1555588798.png" />
</div>
<div className="gateway-card__delimiter" />
<div className="gateway-card__content">
<div className="gateways-list__item-panel">
<span className="gateways-list__item-panel-configure">
<div className="gateways-list__item-panel-configure-shape" />Configure</span>
</div>
</div>
</div>
</div>
<div className="gateways-list__item">
<div className="gateway-card gateway-card--click-enabled">
<div className="gateway-card__header">
<div className="gateway-card__title">Moneta.ru</div>
<img className="gateway-card__image" src="//cdn3.xsolla.com/paymentoptions/paystation/theme_33/108x63/96.1532669540.png" />
</div>
<div className="gateway-card__delimiter" />
<div className="gateway-card__content">
<div className="gateways-list__item-panel">
<span className="gateways-list__item-panel-configure">
<div className="gateways-list__item-panel-configure-shape" />Configure</span>
</div>
</div>
</div>
</div>
<div className="gateways-list__item">
<div className="gateway-card gateway-card--click-enabled">
<div className="gateway-card__header">
<div className="gateway-card__title">Pay with Gift Cards</div>
<img className="gateway-card__image" src="//cdn3.xsolla.com/paymentoptions/paystation/theme_33/108x63/1859.1471587452.png" />
</div>
<div className="gateway-card__delimiter" />
<div className="gateway-card__content">
<div className="gateways-list__item-panel">
<span className="gateways-list__item-panel-configure">
<div className="gateways-list__item-panel-configure-shape" />Configure</span>
</div>
</div>
</div>
</div>
<div className="gateways-list__item">
<div className="gateway-card gateway-card--click-enabled">
<div className="gateway-card__header">
<div className="gateway-card__title">Platbox</div>
<img className="gateway-card__image" src="//cdn3.xsolla.com/paymentoptions/paystation/theme_33/108x63/1172.1481529066.png" />
</div>
<div className="gateway-card__delimiter" />
<div className="gateway-card__content">
<div className="gateways-list__item-panel">
<span className="gateways-list__item-panel-configure">
<div className="gateways-list__item-panel-configure-shape" />Configure</span>
</div>
</div>
</div>
</div>
<div className="gateways-list__item">
<div className="gateway-card gateway-card--click-enabled">
<div className="gateway-card__header">
<div className="gateway-card__title">Promsvyazbank</div>
<img className="gateway-card__image" src="//cdn3.xsolla.com/paymentoptions/paystation/theme_33/108x63/1034.1510836057.png" />
</div>
<div className="gateway-card__delimiter" />
<div className="gateway-card__content">
<div className="gateways-list__item-panel">
<span className="gateways-list__item-panel-configure">
<div className="gateways-list__item-panel-configure-shape" />Configure</span>
</div>
</div>
</div>
</div>
<div className="gateways-list__item">
<div className="gateway-card gateway-card--click-enabled">
<div className="gateway-card__header">
<div className="gateway-card__title">QIWI</div>
<img className="gateway-card__image" src="//cdn3.xsolla.com/paymentoptions/paystation/theme_33/108x63/16.1549032848.png" />
</div>
<div className="gateway-card__delimiter" />
<div className="gateway-card__content">
<div className="gateways-list__item-panel">
<span className="gateways-list__item-panel-configure">
<div className="gateways-list__item-panel-configure-shape" />Configure</span>
</div>
</div>
</div>
</div>
<div className="gateways-list__item">
<div className="gateway-card gateway-card--click-enabled">
<div className="gateway-card__header">
<div className="gateway-card__title">Rixty</div>
<img className="gateway-card__image" src="//cdn3.xsolla.com/paymentoptions/paystation/theme_33/108x63/129.1557128957.png" />
</div>
<div className="gateway-card__delimiter" />
<div className="gateway-card__content">
<div className="gateways-list__item-panel">
<span className="gateways-list__item-panel-configure">
<div className="gateways-list__item-panel-configure-shape" />Configure</span>
</div>
</div>
</div>
</div>
<div className="gateways-list__item">
<div className="gateway-card gateway-card--click-enabled">
<div className="gateway-card__header">
<div className="gateway-card__title">RuRu</div>
<img className="gateway-card__image" src="//cdn3.xsolla.com/paymentoptions/paystation/theme_33/108x63/778.1447072265.png" />
</div>
<div className="gateway-card__delimiter" />
<div className="gateway-card__content">
<div className="gateways-list__item-panel">
<span className="gateways-list__item-panel-configure">
<div className="gateways-list__item-panel-configure-shape" />Configure</span>
</div>
</div>
</div>
</div>
<div className="gateways-list__item">
<div className="gateway-card gateway-card--click-enabled">
<div className="gateway-card__header">
<div className="gateway-card__title">Skrill Digital Wallet</div>
<img className="gateway-card__image" src="//cdn3.xsolla.com/paymentoptions/paystation/theme_33/108x63/465.1475061625.png" />
</div>
<div className="gateway-card__delimiter" />
<div className="gateway-card__content">
<div className="gateways-list__item-panel">
<span className="gateways-list__item-panel-configure">
<div className="gateways-list__item-panel-configure-shape" />Configure</span>
</div>
</div>
</div>
</div>
<div className="gateways-list__item">
<div className="gateway-card gateway-card--click-enabled">
<div className="gateway-card__header">
<div className="gateway-card__title">Sofort Banking</div>
<img className="gateway-card__image" src="//cdn3.xsolla.com/paymentoptions/paystation/theme_33/108x63/694.1532604860.png" />
</div>
<div className="gateway-card__delimiter" />
<div className="gateway-card__content">
<div className="gateways-list__item-panel">
<span className="gateways-list__item-panel-configure">
<div className="gateways-list__item-panel-configure-shape" />Configure</span>
</div>
</div>
</div>
</div>
<div className="gateways-list__item">
<div className="gateway-card gateway-card--click-enabled">
<div className="gateway-card__header">
<div className="gateway-card__title">Steam</div>
<img className="gateway-card__image" src="//cdn3.xsolla.com/paymentoptions/paystation/theme_33/108x63/2596.1447070624.png" />
</div>
<div className="gateway-card__delimiter" />
<div className="gateway-card__content">
<div className="gateways-list__item-panel">
<span className="gateways-list__item-panel-configure">
<div className="gateways-list__item-panel-configure-shape" />Configure</span>
</div>
</div>
</div>
</div>
<div className="gateways-list__item">
<div className="gateway-card gateway-card--click-enabled">
<div className="gateway-card__header">
<div className="gateway-card__title">Ticket Premium</div>
<img className="gateway-card__image" src="//cdn3.xsolla.com/paymentoptions/paystation/theme_33/108x63/563.1550662392.png" />
</div>
<div className="gateway-card__delimiter" />
<div className="gateway-card__content">
<div className="gateways-list__item-panel">
<span className="gateways-list__item-panel-configure">
<div className="gateways-list__item-panel-configure-shape" />Configure</span>
</div>
</div>
</div>
</div>
<div className="gateways-list__item">
<div className="gateway-card gateway-card--click-enabled">
<div className="gateway-card__header">
<div className="gateway-card__title">UCS</div>
<img className="gateway-card__image" src="//cdn3.xsolla.com/paymentoptions/paystation/theme_33/108x63/2607.1481263383.png" />
</div>
<div className="gateway-card__delimiter" />
<div className="gateway-card__content">
<div className="gateways-list__item-panel">
<span className="gateways-list__item-panel-configure">
<div className="gateways-list__item-panel-configure-shape" />Configure</span>
</div>
</div>
</div>
</div>
<div className="gateways-list__item">
<div className="gateway-card gateway-card--click-enabled">
<div className="gateway-card__header">
<div className="gateway-card__title">Vantiv</div>
<img className="gateway-card__image" src="//cdn3.xsolla.com/paymentoptions/paystation/theme_33/108x63/2383.1447070223.png" />
</div>
<div className="gateway-card__delimiter" />
<div className="gateway-card__content">
<div className="gateways-list__item-panel">
<span className="gateways-list__item-panel-configure">
<div className="gateways-list__item-panel-configure-shape" />Configure</span>
</div>
</div>
</div>
</div>
<div className="gateways-list__item">
<div className="gateway-card gateway-card--click-enabled">
<div className="gateway-card__header">
<div className="gateway-card__title">Wallet 1</div>
<img className="gateway-card__image" src="//cdn3.xsolla.com/paymentoptions/paystation/theme_33/108x63/29.1498820638.png" />
</div>
<div className="gateway-card__delimiter" />
<div className="gateway-card__content">
<div className="gateways-list__item-panel">
<span className="gateways-list__item-panel-configure">
<div className="gateways-list__item-panel-configure-shape" />Configure</span>
</div>
</div>
</div>
</div>
<div className="gateways-list__item">
<div className="gateway-card gateway-card--click-enabled">
<div className="gateway-card__header">
<div className="gateway-card__title">WebMoney</div>
<img className="gateway-card__image" src="//cdn3.xsolla.com/paymentoptions/paystation/theme_33/108x63/6.1545732912.png" />
</div>
<div className="gateway-card__delimiter" />
<div className="gateway-card__content">
<div className="gateways-list__item-panel">
<span className="gateways-list__item-panel-configure">
<div className="gateways-list__item-panel-configure-shape" />Configure</span>
</div>
</div>
</div>
</div>
<div className="gateways-list__item">
<div className="gateway-card gateway-card--click-enabled">
<div className="gateway-card__header">
<div className="gateway-card__title">Wechat</div>
<img className="gateway-card__image" src="//cdn3.xsolla.com/paymentoptions/paystation/theme_33/108x63/1026.1525346487.png" />
</div>
<div className="gateway-card__delimiter" />
<div className="gateway-card__content">
<div className="gateways-list__item-panel">
<span className="gateways-list__item-panel-configure">
<div className="gateways-list__item-panel-configure-shape" />Configure</span>
</div>
</div>
</div>
</div>
<div className="gateways-list__item">
<div className="gateway-card gateway-card--click-enabled">
<div className="gateway-card__header">
<div className="gateway-card__title">Yandex.Money</div>
<img className="gateway-card__image" src="//cdn3.xsolla.com/paymentoptions/paystation/theme_33/108x63/27.1512560275.png" />
</div>
<div className="gateway-card__delimiter" />
<div className="gateway-card__content">
<div className="gateways-list__item-panel">
<span className="gateways-list__item-panel-configure">
<div className="gateways-list__item-panel-configure-shape" />Configure</span>
</div>
</div>
</div>
</div>
<div className="gateways-list__item">
<div className="gateway-card gateway-card--click-enabled">
<div className="gateway-card__header">
<div className="gateway-card__title">Your Amazon Account</div>
<img className="gateway-card__image" src="//cdn3.xsolla.com/paymentoptions/paystation/theme_33/108x63/235.1542275431.png" />
</div>
<div className="gateway-card__delimiter" />
<div className="gateway-card__content">
<div className="gateways-list__item-panel">
<span className="gateways-list__item-panel-configure">
<div className="gateways-list__item-panel-configure-shape" />Configure</span>
</div>
</div>
</div>
</div>
<div className="gateways-list__item">
<div className="gateway-card gateway-card--click-enabled">
<div className="gateway-card__header">
<div className="gateway-card__title">paysafecard</div>
<img className="gateway-card__image" src="//cdn3.xsolla.com/paymentoptions/paystation/theme_33/108x63/57.1565603309.png" />
</div>
<div className="gateway-card__delimiter" />
<div className="gateway-card__content">
<div className="gateways-list__item-panel">
<span className="gateways-list__item-panel-configure">
<div className="gateways-list__item-panel-configure-shape" />Configure</span>
</div>
</div>
</div>
</div>
<div className="gateways-list__item">
<div className="gateway-card gateway-card--click-enabled">
<div className="gateway-card__header">
<div className="gateway-card__title">zGold-MOLPoints</div>
<img className="gateway-card__image" src="//cdn3.xsolla.com/paymentoptions/paystation/theme_33/108x63/356.1555587373.png" />
</div>
<div className="gateway-card__delimiter" />
<div className="gateway-card__content">
<div className="gateways-list__item-panel">
<span className="gateways-list__item-panel-configure">
<div className="gateways-list__item-panel-configure-shape" />Configure</span>
</div>
</div>
</div>
</div>
<div className="gateways-list__item">
<div className="gateway-card gateway-card--click-enabled">
<div className="gateway-card__header">
<div className="gateway-card__title">Моби.Деньги</div>
<img className="gateway-card__image" src="//cdn3.xsolla.com/paymentoptions/paystation/theme_33/108x63/2859.1481204349.png" />
</div>
<div className="gateway-card__delimiter" />
<div className="gateway-card__content">
<div className="gateways-list__item-panel">
<span className="gateways-list__item-panel-configure">
<div className="gateways-list__item-panel-configure-shape" />Configure</span>
</div>
</div>
</div>
</div>
</div>
</div>
</div>)

}





const CssH2Extra = styled.span`
  display: flex;
  flex-grow: 1;
  width: 100%;
  margin-top: 4px;
  margin-left: 32px;
  justify-content: flex-end;
  align-items: center;
  height: 36px;
`
